import flat from 'flat'
import ru from './ru.json'

export default {
  ru: flat(ru),
}
